export var currencies = [{
  code: 'GBP',
  symbol: '£'
}, {
  code: 'AUD',
  symbol: '$'
}, {
  code: 'EUR',
  symbol: '€'
}, {
  code: 'USD',
  symbol: '$'
}];